import {fetchJson} from "../utils/SuperAgentFetch";
import ResponseStatusException from "../exceptions/ResponseStatusException";
import {config} from "../config/Config";
import {showError} from "../utils/NotificationsHelper";

export const USER_LIST_REQUESTED = 'USER_LIST_REQUESTED';
/**
 * Action for request of entry.
 *
 * @return {UserListAction}
 */
export const requestUserList = () => {
    return {
        type: USER_LIST_REQUESTED
    };
};

export const USER_LIST_RECEIVED = "USER_LIST_RECEIVED";
/**
 *
 * @param {BaseEntryWithParent} userList
 * @return {ReceiveUserListAction}
 */
export const receiveUserList = (userList) => {
    return {
        type: USER_LIST_RECEIVED,
        userList: userList,
        receivedAt: Date.now()
    }
};

export const USER_LIST_ERROR = 'USER_LIST_ERROR';
/**
 *
 * @param {Object} error
 * @param {String} type type of action
 * @param {Number} errorResponseStatusCode
 * @param {String} errorResponseMessage
 * @return {ReceiveUserListErrorAction}
 */
export const receiveError = (
    error,
    type = USER_LIST_ERROR,
    errorResponseStatusCode = null,
    errorResponseMessage = null
) => {
    return {
        type: type,
        error: error,
        errorResponseStatusCode: errorResponseStatusCode,
        errorResponseMessage: errorResponseMessage,
    }
};


/**
 * Fetch user list
 *
 * @param {boolean} update if is a update request or new loading request
 * @return {function(*=, *): Promise<Object | never>}
 */
export const fetchUserList = (update = false) => {
    return (dispatch, getState) => {
        if (update) {
            //dispatch(requestEntryDetailUpdate());
        } else {
            dispatch(requestUserList());
        }

        //TODO: doresit otazku kolem strankovani
        return fetchJson(`${config.url.API_URL}/auth/custom/users?size=10000`, null, dispatch)
            .then(json => {
                    let res = [];

                    if (json._embedded && json._embedded.users && json._embedded.users.length > 0) {
                        res = json._embedded.users;
                    }
                    dispatch(receiveUserList(res));
                }
            ).catch(error => {
                if(error instanceof ResponseStatusException) {
                    const description = error.response.message ? error.response.message : null;
                    dispatch(receiveError(error, USER_LIST_ERROR, error.response.status, description));
                    showError(dispatch, error.message, description);
                } else {
                    dispatch(receiveError(error, USER_LIST_ERROR));
                    showError(dispatch, error.message);
                }
            });
    }
};